import { companyLicenseActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  licenseData: {
    data: {},
    message: '',
  },
  botStudioSubscriptionData: {
    data: {},
    message: '',
  },
};

const CompanyLicenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.COMPANY_LICENSE_FETCH_REQUEST:
      return { ...state, loading: true, error: '' };
    case ACTION.BOT_SUBSCRIPTION_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.COMPANY_LICENSE_SET_DATA:
      return {
        ...state,
        loading: false,
        error: '',
        licenseData: {
          message: action.payload.message,
          payload: action.payload.payload,
          success: true,
        },
      };

    case ACTION.BOT_SUBSCRIPTION_SET_DATA:
      return {
        ...state,
        loading: false,
        error: '',
        botStudioSubscriptionData: {
          message: action.payload.message,
          payload: action.payload.payload,
          success: true,
        },
      };

    case ACTION.COMPANY_LICENSE_SET_ERROR:
      return { ...state, loading: false, error: action.payload };
    case ACTION.BOT_SUBSCRIPTION_SET_ERROR:
      return { ...state, loading: false, error: action.payload };
    case ACTION.COMPANY_START_FETCH:
      return {
        ...state,
        loading: true,
      };
    case ACTION.REMOVE_LICENSE_DETAILS:
      return {
        ...state,
        licenseData: {},
        botStudioSubscriptionData: {},
      };
    default:
      return state;
  }
};

export default CompanyLicenseReducer;
